/* eslint-disable react/require-default-props */
import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";

interface CustomMobileCheckboxProps {
  label?: string;
  phoneValue?: string;
  onPhoneChange?: (phone: string) => void;
  onCheckboxChange?: (checked: boolean) => void;
  onSendClick?: (phone: string) => void;
  checked?: boolean;
  placeholder?: string;
  maxLength?: number;
  className?: string;
  disabled?: boolean;
  showSendButton?: boolean;
  sendButtonLabel?: string;
  isSending?: boolean;
}

function CustomMobileCheckbox({
  label = "Receive OTP via Mobile Number",
  phoneValue = "",
  onPhoneChange,
  onCheckboxChange,
  onSendClick,
  checked = false,
  placeholder = "Enter phone number",
  maxLength = 10,
  className = "",
  disabled = false,
  showSendButton = false,
  sendButtonLabel = "Send OTP",
  isSending = false
}: CustomMobileCheckboxProps) {
  const [isChecked, setIsChecked] = useState(checked);
  const [phoneNumber, setPhoneNumber] = useState(phoneValue);
  const [hasBeenSent, setHasBeenSent] = useState(false);

  const handleCheckboxChange = (event: { target: { checked: boolean } }) => {
    const { checked: newChecked } = event.target;
    setIsChecked(newChecked);
    if (onCheckboxChange) {
      onCheckboxChange(newChecked);
    }
  };

  const handlePhoneChange = (event: { target: { value: string } }) => {
    const { value } = event.target;
    // Only allow digits
    if (/^\d*$/.test(value)) {
      setPhoneNumber(value);
      if (onPhoneChange) {
        onPhoneChange(value);
      }
    }
  };

  const handleSendClick = () => {
    if (onSendClick && !hasBeenSent) {
      onSendClick(phoneNumber);
      setHasBeenSent(true);
    }
  };

  const getButtonLabel = () => {
    if (isSending) return "Sending...";
    if (hasBeenSent) return "Send OTP";
    return sendButtonLabel;
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="!text-hotShot"
            disabled={disabled}
          />
        }
        label={label}
        className="!font-montserrat !text-xs"
      />

      {isChecked && (
        <div className="mt-4 flex gap-3 w-full">
          <input
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            placeholder={placeholder}
            className="flex-1 h-12 px-4 border-2 rounded focus:outline-none focus:border-hotShot text-sm"
            maxLength={maxLength}
            disabled={disabled}
          />
          {showSendButton && (
            <Button
              variant="contained"
              onClick={handleSendClick}
              disabled={
                !phoneNumber ||
                phoneNumber.length < maxLength ||
                disabled ||
                isSending ||
                hasBeenSent
              }
              className="!uppercase h-12 !cursor-pointer rounded-lg !whitespace-nowrap !text-xs"
            >
              {getButtonLabel()}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default CustomMobileCheckbox;
